define('src/controller/controller',[
    // Libs
    'underscore', 'backbone', 'utils',
    // src
    'src/plugins/backbone.subrouter',
    // services
    'services/session',
    // controllers
    'src/controller/layout-controller'
], function(
    // Libs
    _, Backbone, U,
    // src
    SubRouter,
    // sercices
    Session,
    // controllers
    LayoutController
) {

    var Controller = SubRouter.extend({
        constructor: function(prefix, opt) {
            opt = opt || {};

            this.layoutCtrl = opt.layout || new LayoutController(_.extend({
                context: this,
            }, opt.layoutOptions));
            this.listenTo(this.layoutCtrl, {
                'layout:created': this.onLayoutCreation,
                'layout:switch': this.onLayoutSwitch
            });

            Controller.__super__.constructor.apply(this, arguments);
        },

        getLayout: function() {
            return this.layoutCtrl.getLayout();
        },

        // to be implemented in child class.
        onLayoutCreation: _.noop,
        onLayoutSwitch: _.noop,

        getLayoutInstance: function() {
            return this.layoutCtrl.getLayoutInstance();
        },

        checkAuth: function() {
            if (!Session.isAuthenticated()) {
                Session.onUnauthorized();
                return false;
            }
            return true;
        }

    });

    return Controller;

});

